import React from 'react';
import PropTypes from 'prop-types';

import { Flex, Span } from '@sopranodesign/pulse-components';
import { TemplatingTextInput } from '@sopranodesign/pulse-templating';

const transferVoipCallContent = ({ content, onChange }) => {
  const handleTransferTargetChange = transferTarget => {
    onChange({ transferTarget });
  };

  return (
    <Flex center fat="true" xSpace>
      <Span>to</Span>
      <Flex col fat>
        <TemplatingTextInput
          aria-label="transferTarget"
          placeholder="tel:+4412345678"
          value={content.transferTarget}
          onChange={handleTransferTargetChange}
        />
      </Flex>
    </Flex>
  );
};

transferVoipCallContent.propTypes = {
  onChange: PropTypes.func.isRequired,
  content: PropTypes.shape({
    transferTarget: PropTypes.string.isRequired
  }).isRequired
};

export default transferVoipCallContent;
